export default __webpack_public_path__ + "static/media/skill development-05.26d38567.png";